import { FC, memo } from 'react';

import DefectNietInzetbaar from '@/assets/icons/DefectNietInzetbaar';
import Flag from '@/assets/icons/Flag';
import GeslotenWissel from '@/assets/icons/GeslotenWissel';
import OpenWissel from '@/assets/icons/OpenWissel';
import Versterken from '@/assets/icons/Versterken';

import useMutatieWissel from '../../hooks/useMutatieWissel';

import ActionLink from './ActionLink';
import ExecuteActionLink from './ExecuteActionLink';

const Li = ActionLink;

type ContextMenuOvergangProps = {
  isAllowedToMutate: boolean;
  isAllowedToDefecten: boolean;
  isMultiSelect: boolean;
  isManco: boolean;
};
const ContextMenuOvergang: FC<ContextMenuOvergangProps> = ({
  isAllowedToMutate,
  isAllowedToDefecten,
  isMultiSelect,
  isManco,
}) => {
  const { openWissel, geslotenWissel } = useMutatieWissel();

  return (
    <>
      {Boolean(isAllowedToMutate && !isMultiSelect) && (
        <>
          <Li actionKey='claim-toevoegen' icon={Flag}>
            Claim…
          </Li>
          <Li actionKey='versterken' icon={Versterken} shortcut='Alt+V'>
            Versterk met dit materieel…
          </Li>
          <ExecuteActionLink actionKey='wissel-manco' icon={OpenWissel} action={openWissel} shortcut='Alt+O'>
            Wissel naar manco
          </ExecuteActionLink>
        </>
      )}
      {Boolean(isAllowedToDefecten && !isManco && !isMultiSelect) && (
        <Li actionKey='niet-inzetbaar-vanaf' icon={DefectNietInzetbaar}>
          Meld defect…
        </Li>
      )}
      {Boolean(isAllowedToMutate && isMultiSelect) && (
        <ExecuteActionLink actionKey='wissel-gesloten' icon={GeslotenWissel} action={geslotenWissel} shortcut='Alt+W'>
          Wissel
        </ExecuteActionLink>
      )}
    </>
  );
};

export default memo(ContextMenuOvergang);
